import React from 'react';
import injectStyles from 'react-jss';
import classNames from 'classnames';

import { Block } from '../common';

const styles = {
  wrapper: {
    minHeight: '100vh',
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
};

const SPAPage = ({ classes, className, children, anchor, height, style }) => {
  const heightStyles = {};
  if (!!height) {
    heightStyles.height = `${height}px`;
    heightStyles.maxHeight = `${height}px`;
  }
  return (
    <div
      className={classNames(classes.wrapper, className)}
      style={Object.assign({}, style, heightStyles)}
    >
      <Block id={anchor}>{children}</Block>
    </div>
  );
};

export default injectStyles(styles)(SPAPage);
